import React from 'react'

import api from '../../apiClient/v1'
//Componentes
import { TablaLiderDetalles } from './TablaLiderDetalles.jsx'

let PropTypes = React.PropTypes

export class LiderDetalles extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            lideres: [],
            comunas: []
        }
        this.getComunas=()=>{
            api.otros.comunas()
                .then(comunas=>{
                    this.setState({comunas})
                })
                .catch(err=>{
                    console.log(err)
                })
        }
    }
    getChildContext(){
        return{
            guardarDetalle: (idLiderDetalle, datos)=>{
                return api.fondos().nuevoDetalleLider(idLiderDetalle, datos)
            }
        }
    }
    componentWillMount(){
        api.fondos().getLideres()
            .then(lideres=>{
                api.otros.comunas()
                    .then(comunas=>{
                        this.setState({comunas, lideres})
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            })
            .catch(err=>{
                console.log(err)
            })
    }
    render() {
        return (
            <div className="container">
                <div className="col-md-12 col-xs-12 form-group">
                    <h3>Mantenedor Lideres</h3>
                </div>
                <div className="col-md-12 col-xs-12">
                    <TablaLiderDetalles
                        lideres={this.state.lideres}
                        comunas={this.state.comunas}
                    />
                </div>
            </div>
        )
    }
}
LiderDetalles.childContextTypes = {
    guardarDetalle: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/admin/lider-detalles/LiderDetalles.jsx